export default __webpack_public_path__ + "static/media/startSound.b3ef88a0.mp3";